import instance from "../utils/network";

export interface RunnerEvent {
  id: number;
  url: string;
  link: string;
  title: string;
  description: string;
  startAt: string;
  closeAt: string;
  backgroundColor: string;
  endYn: string;
  detail?: string;
}

export interface RunnerEventRatio {
  width: number;
  height: number;
}

export function runnerEventList(params?: {
  endYn?: "Y" | "N";
  type?: "HOME" | "EVENT" | "MAIN" | null;
}): Promise<RunnerEvent[]> {
  if (params?.endYn) {
    return instance.get(
      `/nest/runner-event/list?endYn=${params?.endYn}&type=${params?.type}`
    );
  }
  return instance.get(`/nest/runner-event/list?type=${params?.type}`);
}

export function runnerEventRatio(): Promise<RunnerEventRatio> {
  return instance.get("/nest/runner-event/ratio");
}

export function runnerEventListWithRandom(params?: {
  endYn?: "Y" | "N";
  type?: "HOME" | "EVENT" | "MAIN" | null;
}): Promise<RunnerEvent[]> {
  if (params?.endYn) {
    return instance.get(
      `/nest/runner-event/list/random?endYn=${params?.endYn}&type=${params?.type}`
    );
  }
  return instance.get(`/nest/runner-event/list?type=${params?.type}`);
}

export function runnerEventDetail(id: number): Promise<RunnerEvent> {
  return instance.get("/nest/runner-event/" + id);
}
